import each from 'lodash/each'
import {
  Base64
} from 'js-base64';

function buildVTTFromChapters(chapters) {
  var vtt = 'WEBVTT  Chapter 1\n';
  each(chapters, (chapter, key) => {
    var start = (new Date(chapter.offset * 1000)).toISOString().substr(11, 11);
    var stop = chapters[key + 1] ? (new Date(chapters[key + 1].offset * 1000)).toISOString().substr(11, 11) : (new Date((chapter.offset + 3600) * 1000)).toISOString().substr(11, 11);
    vtt += start + ' --> ' + stop + '\n';
    vtt += chapter.value + '\n\nChapter ' + (key + 1) + '\n';
  });
  return 'data:text/vtt;charset=utf-8;base64,' + Base64.encode(vtt);
}

class Chapters {
  constructor() {
    this._chapters = [];
  }
  push(chapter) {
    this._chapters.push(chapter);
  }
  exists() {
    return this._chapters.length > 0;
  }

  getNextChapterIdByOffset(offset) {
    var id = this._chapters.length;
    for (var i = 0; i < this._chapters.length; i++) {
      if (this._chapters[i].offset > offset) {
        id = i;
        break;
      }
    }
    return id;
  }

  getById(id) {
    return this._chapters[id] ? this._chapters[id] : null;
  }

  getChaptersVTTasBase64() {
    return buildVTTFromChapters(this._chapters);
  }

  getChapters() {
    var chapters = [];
    this._chapters.forEach((chapter) => {
      chapters.push(Object.assign({}, chapter));
    })
    return chapters;
  }
}

class Chapter {
  constructor(data) {
    this.offset = data.offset;
    this.value = data.value;
  }
}

export {
  Chapters,
  Chapter
};
